import LibraryBrowser from './Browser';

export default function LibraryList() {
    return (
        <LibraryBrowser
            topAdvertiseUnit="library1"
            sidebarAdvertiseUnit="library3"
        />
    );
}
